<template>
    <aside v-if="$route.params.kravicka_id" class="sideMenu position-fixed h-100" :style="!sideMenu ? '' : 'z-index:100;display:block'">

        <router-link to="/">
            <img class="img-fluid header__logo" src="assets/img/adoptuj-kravicku-logo.svg" alt="adoptuj-kravicku-logo">
        </router-link>

        <router-link :to="{ name: 'kravicka', params: { kravicka_id: $route.params.kravicka_id } }" class="sideMenu__close">
            <span class="icon"></span>
        </router-link>

        <ul class="m-sideMenu">
            <!-- Obchod -->
            <li @click="hideSideMenu" class="a-sideMenu__item">
                <router-link :to="{ name: 'obchod', params: { kategoria: 'food', kravicka_id: $route.params.kravicka_id } }">
                    <span class="icon --jedlo"></span>Jedlo
                </router-link>
            </li>
            <li @click="hideSideMenu" class="a-sideMenu__item">
                <router-link :to="{ name: 'obchod', params: { kategoria: 'drink', kravicka_id: $route.params.kravicka_id } }">
                    <span class="icon --pitie"></span>Pitie
                </router-link>
            </li>
            <li @click="hideSideMenu" class="a-sideMenu__item">
                <router-link :to="{ name: 'obchod', params: { kategoria: 'cleanness', kravicka_id: $route.params.kravicka_id } }">
                    <span class="icon --cistota"></span>Čistota
                </router-link>
            </li>
            <li @click="hideSideMenu" class="a-sideMenu__item">
                <router-link :to="{ name: 'obchod', params: { kategoria: 'background', kravicka_id: $route.params.kravicka_id } }">
                    <span class="icon --pozadia"></span>Pozadia
                </router-link>
            </li>

            <!-- Zmenáreň -->
            <li @click="hideSideMenu" class="a-sideMenu__item --spaceTop">
                <router-link :to="{ name: 'zmenaren', params: { kravicka_id: $route.params.kravicka_id } }">
                    <span class="icon --zmenaren"></span>Zmenáreň
                </router-link>
            </li>

            <!-- Zavrieť obchod -->
            <li class="a-sideMenu__item --textLink">
                <router-link :to="{ name: 'kravicka', params: { kravicka_id: $route.params.kravicka_id } }">
                    Zavrieť obchod<span class="icon --zavriet"></span>
                </router-link>
            </li>
        </ul>

        <!--<button id="openShopMenu" class="btn --primary d-xl-none"><span class="icon"></span></button>-->

    </aside>
</template>



<script>
    export default {
        props: [
            'kravicka',
            'sideMenu'
        ],
        mounted() {
        },
        methods: {
            hideSideMenu() {
                this.$emit('hideSideMenu')
            },
        },
    }
</script>
